import Vue from 'vue';
import { i18n } from '../vendors/vue-i18n';

Vue.filter('currency', value => {
    let symbol = document.getElementById("currency_symbol").value;
    return symbol + ''+ value;
});